<div class="image-upload">
  <h4 class="image-upload__label">{{ label }}</h4>

  <!--
    Скрытый input. Не используем display:none — иначе некоторые браузеры
    не позволят программно открыть диалог выбора файла. Вместо этого
    прячем визуально (zero-size) и используем `aria-hidden`.
  -->
  <input
    #fileInput
    type="file"
    [accept]="accept"
    [multiple]="multiple"
    [disabled]="disabled() || uploading()"
    class="image-upload__hidden-input"
    aria-hidden="true"
    tabindex="-1"
    (change)="onFileSelected($event)"
    (blur)="markTouched()" />

  <div class="image-upload__toolbar">
    <button
      mat-stroked-button
      color="primary"
      type="button"
      [disabled]="disabled() || uploading()"
      (click)="triggerFileInput(fileInput)">
      <mat-icon>add_a_photo</mat-icon>
      <span>{{ uploading() ? 'Загрузка…' : 'Добавить фото' }}</span>
    </button>

    <mat-spinner *ngIf="uploading()" diameter="22" class="image-upload__spinner"></mat-spinner>

    <span class="image-upload__count" *ngIf="images().length > 0">
      {{ images().length }} фото
    </span>
  </div>

  <div class="image-grid" *ngIf="images().length > 0; else empty" #grid>
    <div
      *ngFor="let img of displayedImages(); let i = index"
      class="image-grid__item"
      [class.is-disabled]="disabled()">
      <img
        [src]="img.preview"
        [alt]="img.title || ('Фото ' + (i + 1))"
        class="image-grid__thumb"
        (click)="openImage(img.detail)"
        [attr.role]="disabled() ? null : 'button'"
        [attr.tabindex]="disabled() ? -1 : 0"
        (keydown.enter)="openImage(img.detail)"
        (keydown.space)="openImage(img.detail); $event.preventDefault()" />

      <button
        mat-icon-button
        type="button"
        class="image-grid__remove"
        [disabled]="disabled()"
        (click)="removeImage(i, $event)"
        [attr.aria-label]="'Удалить фото ' + (i + 1)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!--
    Кнопка «Показать все» / «Свернуть». `canCollapse` уже требует
    `images.length > 0`, поэтому кнопка автоматически скрывается,
    когда картинок ≤ 2 строк (в т.ч. после удаления части).
  -->
  <button
    mat-button
    type="button"
    class="image-upload__toggle"
    *ngIf="canCollapse()"
    (click)="toggleExpanded()">
    <mat-icon>{{ expanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
    <span>{{ expanded() ? 'Свернуть' : ('Показать все (' + hiddenCount() + ')') }}</span>
  </button>

  <ng-template #empty>
    <p class="image-upload__empty">{{ emptyHint }}</p>
  </ng-template>
</div>
